<template>
<standard-dialog v-model="visible" scrollable persistent :width="600">

  <template slot="title">
    <span class="title">{{ $t('reactor.macro_edit')}}</span>
  </template>

  <v-form ref="form" v-model="validEditor" lazy-validation>

    <name-text-field v-model="nameText" :rules="rulesName"></name-text-field>

    <device-selector multiple box v-model="triggers" :rules="rulesTrigger" :label="$t('reactor.select_trigger')" :gateways="[item.mac]" :functypes="triggerTypes" clearable></device-selector>
    <template v-for="(t, t_index) in triggers">
      <device-item flat :item="getDevice(t)" :eventlog="{}" :key="t_index">
        <template slot-scope="data">
          <v-list-tile-action class="ml-2"
          :style="[isOneColumn(data.device.functype) ? {'max-width': '90px'} : {'max-width': '220px'}]">
            <trigger-item v-model="valuesT[data.device.key]" :item="data.device" :delTrigger="delTrigger"></trigger-item>
          </v-list-tile-action>
        </template>
      </device-item>
    </template> <br>
    <!-- <v-layout row wrap v-if="thresholdRequired">
      <v-flex xs6 class="pr-2">
        <device-item flat :item="getDevice(trigger)" :eventlog="{}"></device-item>
      </v-flex>
      <v-flex xs3 class="pr-2">
        <operator-selector v-model="operator"></operator-selector>
      </v-flex>
      <v-flex xs3 class="pl-2">
        <v-text-field box mask="####" v-model="threshold" :rules="rulesThreshold" :label="$t('reactor.select_threshold')"></v-text-field>
      </v-flex>
    </v-layout> -->
    <device-selector box multiple v-model="actions" :rules="rulesAction" :label="$t('reactor.select_action')" :gateways="[item.mac]" :ctrltypes="actionTypes" clearable></device-selector>
    <template v-for="a in actions">
      <device-item flat :item="getDevice(a)||{}" :eventlog="{}" :key="a">
        <template slot-scope="data">
          <v-list-tile-action style="max-width: 90px" class="ml-2">
            <state-selector v-model="values[data.device.key]" :item="data.device"></state-selector>
          </v-list-tile-action>
        </template>
      </device-item>
    </template>
  </v-form>

  <template slot="actions">
    <v-btn v-if="item && isEnabled" :loading="toggling" color="red" flat @click="toggleMacro(false)">{{ $t('reactor.disable') }}</v-btn>
    <v-btn v-else-if="item" :loading="toggling" color="green" flat @click="toggleMacro(true)">{{ $t('reactor.enable') }}</v-btn>
    <v-spacer></v-spacer>
    <v-btn v-if="!saving" :loading="removing" flat color="accent" @click="remove">{{ $t('reactor.delete') }}</v-btn>
    <v-btn color="primary" flat @click="save" :loading="saving" :disabled="!canSave">{{ $t('reactor.save') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'
import DeviceItem from '@/components/device/DeviceItem'
import DeviceAvatar from '@/components/device/DeviceAvatar'
import DeviceSelector from '@/components/device/DeviceSelector'
import DeviceStateSelector from '@/components/device/DeviceStateSelector'
import OperatorSelector from './OperatorSelector'
import MacroTriggerItem from './MacroTriggerItem'

export default {
  name: 'MacroEditorDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    'standard-dialog': Dialog,
    'device-avatar': DeviceAvatar,
    'name-text-field': NameTextField,
    'device-item': DeviceItem,
    'device-selector': DeviceSelector,
    'state-selector': DeviceStateSelector,
    'trigger-item': MacroTriggerItem
  },
  data() {
    return {
      saving: false,
      removing: false,
      toggling: false,
      validEditor: false,
      nameText: null,
      rulesName: [
        v => (v && (this.item.title == v || !this.macroNames.includes(v))) || this.$t('reactor.name_should_not_be_duplicated')
      ],
      trigger: null,
      triggers: [],
      delTrigger: '',
      triggerTypes: [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 28, 29, 37, 40, 42, 43],
      thresholdTypes: [11, 12, 13, 15, 16, 17, 18, 19, 20, 21, 22, 28, 29, 37, 40, 42, 43],
      rulesTrigger: [
        v => !!v || this.$t('reactor.trigger_is_required')
      ],
      actions: [],
      actionTypes: [],
      rulesAction: [
        v => !!v || this.$t('reactor.action_is_required')
      ],
      values: {},
      valuesT: {},
      threshold: null,
      rulesThreshold: [
        v => (parseInt(v) >= 0 && parseInt(v) <= 9999) || this.$t('reactor.threadhold_between', {
          from: 0,
          to: 9999
        })
      ],
      operator: null,
      actionTypes: [23, 24, 25, 26, 31, 32, 33, 34, 35, 41]
    }
  },
  watch: {
    isEnabled() {
      this.toggling = false;
    },
    macroNames(val) {
      if (this.saving) {
        if (val.includes(this.nameText)) {
          this.$emit('toast', this.$t('reactor.saved'));
          this.saving = false;
          this.visible = false;
        }
      }
      if (this.removing) {
        if (!val.includes(this.item.title)) {
          this.visible = false;
        }
      }
    },
    thresholdRequired(val) {
      if (!val) {
        this.operator = null;
        this.threshold = null;
      }
    },
    triggers: {
      immediate: true,
      handler(newValue, oldValue) {
        var newStatus = newValue || [];
        var oldStatus = oldValue || [];
        if (oldStatus.length != 0) {
          this.delTrigger = oldStatus.filter(x => !newStatus.includes(x))[0] || '';
          if (this.delTrigger) this.$delete(this.valuesT, this.delTrigger);
        };
          if (newStatus.length > 10) {
          this.$emit('toast', this.$t('kanban.selection_limit_reached'));
        }
        while (newStatus.length > 10) {
          newStatus.splice(newStatus.length - 1, 1);
        }
      }
    },
    actions(val) {
      if (val.length > 70) {
        this.$emit('toast', this.$t('kanban.selection_limit_reached'));
      }
      while (val.length > 70) {
        val.splice(val.length - 1, 1);
      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isEnabled() {
      return ((this.userMacro[this.item.mac] || []).find(m => m.title == this.item.title) || {}).enabled == 1 || this.item.mix_schedule_enabled;
    },
    canSave() {
      return this.validEditor;
    },
    macroNames() {
      return (this.userMacro[this.item.mac] || []).map(s => s.title);
    },
    thresholdRequired() {
      if (this.trigger) {
        let d = this.getDevice(this.trigger) || {};
        return this.thresholdTypes.includes(d.functype);
      }
    }
  },
  methods: {
    onValueBlur() {
      // this.values.__ob__.dep.notify();
      // this.valuesT.__ob__.dep.notify();
    },
    getDevice(key) {
      let [mac, uid, cid] = key.split('-');
      let d = (((this.userDevice[mac] || {})[`${mac}-${uid}`] || {}).channel || {})[key] || {};
      return {
        ...d,
        key: key,
        targetName: ((this.userTargetName[mac] || {})[uid] || {})[cid]
      }
    },
    isOneColumn(functype) {
      return [13, 14, 20].includes(functype);
    },
    async toggleMacro(val) {
      this.toggling = true;
      let ref = this.$db.ref('command/gateway').push();
      try {
        if (this.item.has_schedule) {
          await ref.set({
            mac: this.item.mac,
            cmd: "macroschedulecontrol",
            title: "!@_mix_" + this.item.title,
            enabled: val ? 1 : 0
          });
        } else {
          await ref.set({
            mac: this.item.mac,
            cmd: 'macrocontrol',
            title: this.item.title,
            enabled: val ? 1 : 0
          });
        };
      } catch (err) {
        this.toggling = false;
        this.$emit('toast', this.$t('reactor.permission_denied'));
        return;
      }
      await this.refreshMac(this.item.mac);
      this.visible = false;
      this.$emit('toast', this.$t(val ? 'reactor.enable_macro' : 'reactor.disable_macro', {
        name: this.item.title,
        mac: (this.userMacInfo[this.item.mac] || {}).hostname || this.item.mac
      }));
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      await this.removeMacro();
      await this.saveMacro();
      await this.refreshMac(this.item.mac);
    },
    async remove() {
      this.removing = true;
      await this.removeMacro();
      await this.refreshMac(this.item.mac);
    },
    async saveMacro() {
      let v = {
        macros: [{
          title: this.nameText,
          enabled: this.isEnabled ? 1 : 0,
          triggers: this.triggers.map(t => {
            let [, uid, cid] = t.split('-');
            return {
              dataunit: 0,
              duration: 0,
              field: 'sensorvalue',
              target: {
                dev: parseInt(uid),
                ch: parseInt(cid),
                if: (parseInt(uid) >>> 8) << 8
              },
              op: this.valuesT[t] && this.valuesT[t]['op'] || '!=',
              threshold: parseInt(this.valuesT[t] && this.valuesT[t]['th'] || '0')
            }
          }),
          scene: {
            comps: this.actions.map(d => {
              let [, uid, cid] = d.split('-');
              return {
                target: {
                  dev: parseInt(uid),
                  ch: parseInt(cid),
                  if: (parseInt(uid) >>> 8) << 8
                },
                value: parseInt(this.values[d] || '0')
              }
            })
          }
        }]
      };
      // console.log('SET', JSON.stringify(v));
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          cmd: 'jsonsetall',
          mac: this.item.mac,
          val: v
        });
      } catch (err) {
        this.$emit('toast', this.$t('scene.permission_denied'));
        this.saving = false;
        return;
      }

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.saving = false;
        }
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    },
    async removeMacro() {
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          cmd: 'jsondel',
          mac: this.item.mac,
          val: {
            macros: [{
              title: this.item.title
            }]
          }
        });
      } catch (err) {
        this.$emit('toast', this.$t('scene.permission_denied'));
        this.removing = false;
        return;
      }

      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.removing = false;
        }
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    }
  },
  mounted() {
    this.$refs.form.reset();
    this.nameText = this.item.title;
    // (this.item.triggers || []).forEach(t => {
    //   let key = `${this.item.mac}-${t.target.dev}-${t.target.ch}`;
    //   this.trigger = key;
    //   this.operator = t.op;
    //   this.threshold = t.threshold;
    // });
    (this.item.triggers || []).forEach(t => {
      let key = `${this.item.mac}-${t.target.dev}-${t.target.ch}`;
      this.triggers.push(key);
      this.valuesT[key] = {op: t.op, th: t.threshold};
    });
    ((this.item.scene || {}).comps || []).forEach(c => {
      let key = `${this.item.mac}-${c.target.dev}-${c.target.ch}`;
      this.actions.push(key);
      this.values[key] = c.value;
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reactor/MacroEditorDialog.vue